import { writable } from "svelte/store";

export const userProfileStore = writable({
  name: "...",
  description: "...",
  slogan: "...",
  avatar_url: "...",
  youtube_url: "...",
  instagram_url: "...",
  spotify_url: "...",
});
